var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              staticClass: "dialogmimaxg",
              attrs: {
                width: "60%",
                visible: _vm.Passwordmodification,
                "show-close": false,
                "close-on-click-modal": false,
                "modal-append-to-body": false,
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.Passwordmodification = $event
                },
              },
            },
            [
              _vm.judgeWeb
                ? _c(
                    "div",
                    [
                      _c(
                        "el-steps",
                        { attrs: { active: _vm.active, space: "100px" } },
                        [
                          _c("el-step", { attrs: { title: "" } }),
                          _c("el-step", { attrs: { title: "" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.active == 2
                ? _c("div", [
                    _c("div", { staticClass: "toutxt" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$i18.language("AI智能推荐设置")) + " "
                      ),
                    ]),
                    _c("div", { staticClass: "toutxt1" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$i18.language(
                            "完成AI智能推荐设置，系统将在每周一推荐采购商，可通过总览中的「AI智能推荐」查看。"
                          )
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm2",
                            staticClass: "demo-ruleFormty",
                            attrs: {
                              model: _vm.ruleForm2,
                              rules: _vm.rulest2,
                              "label-position": "top",
                              "label-width": "100px",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "open-ai-switch" },
                              [
                                _c(
                                  "p",
                                  { staticStyle: { "font-weight": "600" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$i18.language("开启智能推荐"))
                                    ),
                                  ]
                                ),
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": _vm.ruleForm2.opened
                                      ? this.$i18.language("已开启")
                                      : this.$i18.language("已关闭"),
                                  },
                                  model: {
                                    value: _vm.ruleForm2.opened,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm2, "opened", $$v)
                                    },
                                    expression: "ruleForm2.opened",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.ruleForm2.opened,
                                    expression: "!ruleForm2.opened",
                                  },
                                ],
                                staticClass: "LaterTips",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18.language(
                                      "您可以稍后在「总览」的「AI智能推荐」中开启推荐"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c("productAndHs", {
                              ref: "productAndHs",
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: {
                                disabled: !_vm.ruleForm2.opened,
                                form: _vm.ruleForm2,
                                defaultHsForm: _vm.defaultHsForm,
                              },
                              on: {
                                hscodeSearch: (item) =>
                                  _vm.showHsCodeSelect(0, item),
                              },
                            }),
                            _c(
                              "el-form-item",
                              {
                                class: [
                                  !_vm.ruleForm2.opened ? "is-disabled" : "",
                                  "form-item",
                                  "remove-icon",
                                  "multiple-box",
                                ],
                                attrs: {
                                  label: _vm.$i18.language("所属行业："),
                                  prop: "belonging_to_industrys",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: !_vm.ruleForm2.opened
                                      ? "is-disabled ai_generate"
                                      : "ai_generate",
                                    on: {
                                      click: function ($event) {
                                        return _vm.aiGenerate("industry")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$i18.language("AI生成")))]
                                ),
                                _c("customSelect", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.industry_loading,
                                      expression: "!industry_loading",
                                    },
                                  ],
                                  class: !_vm.ruleForm2.opened
                                    ? "is-disabled"
                                    : "",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$i18.language("请选择"),
                                    keyValue: "val",
                                    data: _vm.contactHsCodes,
                                  },
                                  on: {
                                    clickSelect: _vm.showIndustrySelect,
                                    removeTag: _vm.handleRemove,
                                  },
                                }),
                                _c("el-skeleton", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.industry_loading,
                                      expression: "industry_loading",
                                    },
                                  ],
                                  attrs: { animated: "", rows: 1 },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.aiGenerateData.showIndustryReason,
                                        expression:
                                          "aiGenerateData.showIndustryReason",
                                      },
                                    ],
                                    staticClass: "reason",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "reason-why-icon",
                                      attrs: { name: "reason-why" },
                                    }),
                                    _c("span", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$i18.language(
                                            "推荐原因：按照您输入的商品的关键词的行业上下游关系，AI智能推荐了的相关行业"
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                class: [
                                  !_vm.ruleForm2.opened ? "is-disabled" : "",
                                  "form-item",
                                  "remove-icon",
                                  "elselect",
                                ],
                                attrs: {
                                  label: _vm.$t(
                                    "dashboardCont.interestedCountry"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    class: !_vm.ruleForm2.opened
                                      ? "is-disabled ai_generate"
                                      : "ai_generate",
                                    attrs: { disabled: !_vm.ruleForm2.opened },
                                    on: {
                                      click: function ($event) {
                                        return _vm.aiGenerate("country")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$i18.language("AI生成")))]
                                ),
                                _c("customSelect", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.country_loading,
                                      expression: "!country_loading",
                                    },
                                  ],
                                  class: !_vm.ruleForm2.opened
                                    ? "is-disabled"
                                    : "",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder:
                                      _vm.$i18.language(
                                        "请可以选择多个感兴趣的国家/地区"
                                      ),
                                    keyValue: "value",
                                    data: _vm.ruleForm2.country,
                                  },
                                  on: {
                                    clickSelect: _vm.xunxioanggj,
                                    removeTag: _vm.handleRemoveCountry,
                                  },
                                }),
                                _c("el-skeleton", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.country_loading,
                                      expression: "country_loading",
                                    },
                                  ],
                                  attrs: { animated: "", rows: 1 },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.aiGenerateData.showCountryReason,
                                        expression:
                                          "aiGenerateData.showCountryReason",
                                      },
                                    ],
                                    staticClass: "reason",
                                  },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "reason-why-icon",
                                      attrs: { name: "reason-why" },
                                    }),
                                    _c("span", {
                                      staticClass: "content",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$i18.language(
                                            "推荐原因：上述国家/地区，近一年的相关品类<strong>从中国采购的量较大</strong>，建议关注。"
                                          )
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _vm.judgeWeb
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "buttont",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.buttontmat2("ruleForm2")
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("dashboardCont.sureNext")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                !_vm.judgeWeb
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "buttont",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.buttontmat2("ruleForm2")
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("sure")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm.active == 3
                ? _c("div", [
                    _c("div", { staticClass: "toutxt" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("dashboardCont.useWeChat")) + " "
                      ),
                    ]),
                    _c("div", { staticClass: "toutxt1" }, [
                      _vm._v(_vm._s(_vm.$t("dashboardCont.useWeChatOver"))),
                    ]),
                    _c("div", [
                      _c("div", [
                        _c("iframe", {
                          staticClass: "imgurl",
                          attrs: {
                            id: "wx_qrcode",
                            width: "320px",
                            height: "290px",
                            scrolling: "no",
                            src: _vm.iframeUrl,
                            frameborder: "0",
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "fsapmt" }, [
                        _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "buttont",
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.buttontmat3()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("dashboardCont.scanCode")))]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "tlidhcu",
                            on: {
                              click: function ($event) {
                                return _vm.clicktetuli()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("dashboardCont.skip")) + ">>")]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.industryVisible,
            title: _vm.$i18.language("选择行业"),
          },
          on: {
            "update:visible": function ($event) {
              _vm.industryVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "hscode-data" },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    size: "mini",
                    placeholder: _vm.$t("productDetail.pleaseEnterkeyWord"),
                  },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.getIndustryDatated.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.filterIndustryText,
                    callback: function ($$v) {
                      _vm.filterIndustryText = $$v
                    },
                    expression: "filterIndustryText",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-input__icon el-icon-search",
                    attrs: { slot: "suffix" },
                    on: { click: _vm.getIndustryDatated },
                    slot: "suffix",
                  }),
                ]
              ),
              _c(
                "div",
                { staticClass: "shotree" },
                [
                  _c("el-tree", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingIndustryTree,
                        expression: "loadingIndustryTree",
                      },
                    ],
                    ref: "industryTree",
                    staticClass: "filter-tree",
                    attrs: {
                      data: _vm.industryData,
                      "default-checked-keys": _vm.defaultIndustryKeys,
                      "default-expanded-keys": _vm.defaultExpandedIndustryKeys,
                      props: _vm.defaultProps,
                      "show-checkbox": "",
                      "node-key": "id",
                      "filter-node-method": _vm.filterIndustryNode,
                    },
                    on: { check: _vm.checkIndustryTree },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ node }) {
                          return _c(
                            "span",
                            { staticClass: "custom-tree-node" },
                            [
                              !_vm.filterIndustryText
                                ? _c("span", [_vm._v(_vm._s(node.label))])
                                : _vm._e(),
                              _vm.filterIndustryText
                                ? _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        node.label.replace(
                                          new RegExp(
                                            _vm.filterIndustryText,
                                            "g"
                                          ),
                                          `<font>${_vm.filterIndustryText}</font>`
                                        )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "btn-group" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "sub-confirm-btn",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.industryVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "confirm-btn",
                      attrs: { size: "small" },
                      on: { click: _vm.confirmIndustry },
                    },
                    [_vm._v(_vm._s(_vm.$t("sure")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("country-select", {
        ref: "countrySelect",
        on: { changeCountryF: _vm.changeCountryF },
      }),
      _c("hsCodeDialog", {
        ref: "hsCodeDialog-0",
        attrs: { codeCheckLength: 4, submitCodeLimit: 5 },
        on: { confirmHsCode: _vm.confirmHsCode },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }